import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/home";
import OrderPage from "./pages/orderpage";
import GTM from "./GTM";
import { CartProvider } from "./pages/CartContext";
import ProductDetails from "./pages/ProductDetails";
import Header from "./components/Header";

import { Toaster } from "react-hot-toast";

function App() {
  return (
    <div className="App">
      <GTM />
      <Toaster 
        position="top-center" 
        reverseOrder={false} 
        toastOptions={{
          duration: 3000,
        }}
      />
      <CartProvider>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/orderpage" element={<OrderPage />} />
            <Route path="/product-details" element={<ProductDetails />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}


export default App;
